module.exports = __webpack_public_path__ + "img/header-weddingRingsSecretHeart@2x.bb29243.webp";